import HelpTextManager from "./HelpTextManager";

export default HelpTextManager;
export { HelpTextManager };
